import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 17.884 17.795"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7989",
  d: "m9.681 12.539 5.061-5.061Zm-5.893-1.592a7.106 7.106 0 0 1 2.343-5.258l2.128 2.129V2.452H2.894L4.861 4.42a8.921 8.921 0 0 0 5.186 15.425v-1.807a7.157 7.157 0 0 1-6.259-7.091Zm16.1 0a8.941 8.941 0 0 0-8.048-8.9v1.809a7.121 7.121 0 0 1 3.917 12.349l-2.128-2.128v5.365h5.361l-1.967-1.967a8.882 8.882 0 0 0 2.861-6.528Z",
  transform: "translate(-2 -2.05)",
  style: {"fill":"#1e2021"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };